import React from 'react';

export default function AdminSupport() {
    return (
        <div>
            <h1>AdminSupport</h1>
        </div>
    );
}
